import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CustomControlsModule } from './custom-controls/custom-controls.module';
import { ToggleColumnDirective } from './directives/toggle-column/toggle-column.directive';
import { ToggleTableDirective } from './directives/toggle-table/toggle-table.directive';
import { DateFormatPipe } from './pipes/date-format.pipe';
import { StepperModule } from './steppers/stepper.module';

@NgModule({
  declarations: [ToggleTableDirective, ToggleColumnDirective, DateFormatPipe],
  imports: [CommonModule, CustomControlsModule, StepperModule],
  exports: [CustomControlsModule, StepperModule, ToggleTableDirective, ToggleColumnDirective, DateFormatPipe],
})
export class PartnerhubModule {}
